<template>
  <div>
    <h1>Lista de Papéis</h1>
    <b-card>
      <div class="d-flex mb-2">
        <div class="mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'acl_create' }"
            v-if="$can('area:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table striped hover :items="roles" :fields="fields" show-empty>
        <template #cell(updated_at)="{ item }">
          {{ item.updated_at | format_date("DD/MM/YYYY HH:mm") }}
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('role:edit')"
            :view_delete="$can('role:delete')"
            edit_to="acl_edit"
            @delete="delete_role"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
    </b-card>

    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        @input="loadData()"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
  }),
  computed: {
    ...mapState("acl", ["roles", "role", "pagination"]),
    fields() {
      return [
        { key: "id", label: "#", class: "col-1" },
        { key: "name", label: "Papel" },
        { key: "updated_at", label: "Atualizado em" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("acl", ["ActionGetAll", "ActionDelete"]),
    async delete_role(role) {
      try {
        await this.ActionDelete(role.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    searchTerm() {
      this.page = 1;
      this.loadData();
      this.$router.push({
        query: {
          page: this.page,
          q: this.termo_pesquisa,
        },
      });
    },
    async loadData() {
      try {
        await this.ActionGetAll({ page: this.page, q: this.termo_pesquisa });
      } catch (error) {
        console.log("ERROR", error);
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    this.loadData();
  },
};
</script>

<style></style>
